var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOperationsRefresh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8935 7C18.6699 7 21.205 8.54272 22.8564 10.7572L20.6041 10.0234C20.079 9.85229 19.5146 10.1393 19.3435 10.6644C19.1725 11.1895 19.4594 11.7539 19.9846 11.925L24.756 13.4796C25.0605 13.5788 25.3941 13.5262 25.6533 13.338C25.9125 13.1498 26.0658 12.8489 26.0658 12.5286L26.0645 6.99976C26.0643 6.44748 25.6165 5.99987 25.0642 6C24.5119 6.00013 24.0643 6.44795 24.0645 7.00024L24.0649 9.06382C22.0892 6.68183 19.1862 5 15.8935 5C9.86714 5 5 9.93499 5 16C5 22.065 9.86714 27 15.8935 27C18.5049 27 20.9029 26.071 22.7782 24.5251C23.2043 24.1739 23.265 23.5436 22.9137 23.1174C22.5624 22.6913 21.9322 22.6306 21.506 22.9819C19.9741 24.2447 18.0218 25 15.8935 25C10.9918 25 7 20.9807 7 16C7 11.0193 10.9918 7 15.8935 7ZM25 22C25.5523 22 26 21.5523 26 21C26 20.4477 25.5523 20 25 20C24.4477 20 24 20.4477 24 21C24 21.5523 24.4477 22 25 22Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperationsRefresh);
export default __webpack_public_path__ + "static/media/OperationsRefresh.f4e698e3.svg";
export { ForwardRef as ReactComponent };